/* eslint-disable complexity */
/* eslint-disable max-len */
/* eslint-disable max-statements */
import { useEffect, useState } from "react";
import { getCarHistoryReportURL } from "../../../../utils/helpers/get-car-history-report-url";
import useCustomHistoryOperations from "../../../../hooks/use-custom-history-operation";
import { useHistory } from "react-router-dom";
import parseLocationSearchParams from "../../../../utils/helpers/parse-location-search-params";
import { useSelector } from "react-redux";
import { SCREEN_STATES } from "../../../../constants/car-history-constants";
import { NUMBER } from "../../../../constants/app-constants";
import { CMS_SLUG_CONSTANTS } from "../../../../constants/optimize-constants";
import { carHistoryReportSteps } from "../../../../config/au.desktop/car-history-report-config";
import { validateEmail } from "../../../../utils/validators/email-validator";
import routesConstant from "../../../../constants/routes-constant";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import { CHR_GA_EVENTS } from "../../car-history-report-landing-page/tracking";
// import { fetchRegoDetails } from "../../car-history-report/actions";
export const useCarHistoryForm = (
    {
        fetchRegoDetailsConnect = () => {},
        updateChrFormStateConnect = () => {},
        createChrServiceOrderConnect = () => {},
        getGuestTokenInfoConnect = () => {},
        fetchChrLandingDataConnect = () => {},
        updateChrServiceOrderConnect = () => {},
        updateChrFormDetailsConnect = () => {},
        fetchChrServiceOrderListConnect = () => {}
    } = {}
) => {
    const history = useHistory();
    const {location} = history;
    const queryParams = parseLocationSearchParams(location.search);
    const {carHistoryReport, user, carDetails: {content = {}}} = useSelector((state) => state);
    const {vin: carDetailsVin, year: carDetailsYear, state: carDetailsState} = content || {};
    const {currentFormState, regoDetails, chrServiceOrder} = carHistoryReport || {};
    const [selectedProduct, setSelectedProduct] = useState({
        productTag: {},
        productDetails: ""
    });
    const {isLoggedIn, email} = user || {};
    const [isVinActive, setIsVinActive] = useState(false);
    const {data: regoDetailsData = {}, chrRegoFormDetails = {}} = regoDetails || {};
    const {data: vehicleVariants = []} = regoDetailsData || {};
    const [selectedVariant, setSelectedVariant] = useState({
        variantId: vehicleVariants[0]?.id || "",
        variantDetails: vehicleVariants[0]
    });

    const {orderId = "", isLoading: chrServiceOrderLoading} = chrServiceOrder || {};

    const {customPush} = useCustomHistoryOperations();
    // updates form state
    const handleOnChange = (value, questionKey) => {
        let formattedValue = value;
        if (typeof value === "string") {
            formattedValue = value.toLowerCase().trim();
        }
        updateChrFormDetailsConnect({[questionKey]: formattedValue});

        if (questionKey === "year" || questionKey === "state") {
            trackDesktopCustomEventsAU(CHR_GA_EVENTS.FORM_INPUT, {
                ...CHR_GA_EVENTS.FORM_INPUT,
                eventAction: `${questionKey}_selected`,
                eventLabel: value
            });
        }
    };

    const handleVinRegoChange = (value) => {
        const trimmedValue = value.toUpperCase().trim();

        // If length is 17, treat as VIN and clear rego
        if (trimmedValue.length === NUMBER.SEVENTEEN) {
            updateChrFormDetailsConnect({
                vin: trimmedValue,
                regNo: "" // Clear rego
            });
        } else {
            updateChrFormDetailsConnect({
                regNo: trimmedValue,
                vin: "" // Clear VIN
            });
        }
    };

    useEffect(() => {
        if (email && isLoggedIn) {
            updateChrFormDetailsConnect({userEmail: email});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email, isLoggedIn]);

    useEffect(() => {
        // update details if the user is coming from CDP
        if (carDetailsVin && carDetailsYear && carDetailsState) {
            setIsVinActive(true);
            updateChrFormDetailsConnect({vin: carDetailsVin, year: carDetailsYear, state: carDetailsState});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carDetailsVin, carDetailsYear, carDetailsState]);

    const handleRedirection = (route, chrOrderId) => {
        const { relativeURL } = getCarHistoryReportURL(route, queryParams, chrOrderId);
        customPush(relativeURL);
    };
    // vin toggle
    const handleTab = () => {
        // todo:deepak add constants
        const resetFieldKey = isVinActive ? "vin" : "regNo";
        handleOnChange("", resetFieldKey);
        setIsVinActive(!isVinActive);
        if (!isVinActive) {
            trackDesktopCustomEventsAU(CHR_GA_EVENTS.ALLOWS_ENTERING_VIN, {
                ...CHR_GA_EVENTS.ALLOWS_ENTERING_VIN,
                eventLabel: chrRegoFormDetails.vin
            });
        }

    };
    const createChrServiceOrder = async () => {
        await createChrServiceOrderConnect({
            email: chrRegoFormDetails.userEmail,
            carDetails: {
                ...(chrRegoFormDetails.regNo && {regNo: chrRegoFormDetails.regNo}),
                ...(chrRegoFormDetails.year && {year: chrRegoFormDetails.year}),
                ...(chrRegoFormDetails.state && {state: chrRegoFormDetails.state}),
                ...(chrRegoFormDetails.vin && {vin: chrRegoFormDetails.vin})
            }
        });
        // const {orderId: createdOrderId} = response || {};

    };

    const handleKBBNotFound = async ({createOrderId = "", carDetails}) => {
        try {
            await updateChrServiceOrderConnect({
                orderId: createOrderId,
                payload: {
                    carDetails,
                    id: carDetails?.externalId || carDetails?.id
                }
            });
            const landingDataResponse = await fetchChrLandingDataConnect({
                orderId: createOrderId
            });
            const {selectedProductTag} = landingDataResponse || {};
            await updateChrServiceOrderConnect({
                orderId: createOrderId,
                payload: {
                    carDetails,
                    id: carDetails?.externalId || carDetails?.id,
                    ...(selectedProductTag && {selectedProductTag})
                }
            });
            handleRedirection(carHistoryReportSteps.paymentSummary.route, createOrderId);
            trackDesktopCustomEventsAU(CHR_GA_EVENTS.ON_PROCEED_TO_REPORT_CLICKED, {
                ...CHR_GA_EVENTS.ON_PROCEED_TO_REPORT_CLICKED
            });
            updateChrFormStateConnect(SCREEN_STATES.ENTER_DETAILS);
        } catch (e) {
            // console.log(e);
        }
    };

    const fetchKbbData = () => {
        fetchRegoDetailsConnect({
            ...(chrRegoFormDetails.regNo && {regNo: chrRegoFormDetails.regNo}),
            ...(chrRegoFormDetails.year && {year: chrRegoFormDetails.year}),
            ...(chrRegoFormDetails.state && {state: chrRegoFormDetails.state}),
            ...(chrRegoFormDetails.vin && {vin: chrRegoFormDetails.vin})
        }).then((response) => {
            const {data: kbbResponse, createOrderId} = response || {};
            const agCount = Array.isArray(kbbResponse) ? kbbResponse.length : 0;
            trackDesktopCustomEventsAU(CHR_GA_EVENTS.AUTOGRAB_DETAILS, {
                ...CHR_GA_EVENTS.AUTOGRAB_DETAILS,
                eventLabel: String(agCount)
            });
            if (kbbResponse.length >= NUMBER.TWO) {
                updateChrFormStateConnect(SCREEN_STATES.VARIANT_SELECTION);
            } else if (kbbResponse.length === NUMBER.ONE) {
                if (!kbbResponse[0]?.id) {
                    handleKBBNotFound({createOrderId, carDetails: kbbResponse[0]});
                } else {
                    // eslint-disable-next-line no-use-before-define
                    updateAndFetchLandingData({createOrderId, carDetails: kbbResponse[0], isSingleVariant: true});
                }
            } else if (!kbbResponse.length) {
                updateChrFormStateConnect(SCREEN_STATES.VEHICLE_NOT_FOUND);
            }
        }).catch(() => {
            // console.log("Error", err);
        });
    };

    const fetchKbbDataAndCreateOrder = async () => {
        if (!isLoggedIn) {
            await getGuestTokenInfoConnect({ username: chrRegoFormDetails.userEmail, addressType: "EMAIL", token: "" });
        }
        let createRequest = {};
        if (!isVinActive) {
            createRequest = { regNo: chrRegoFormDetails.regNo, year: chrRegoFormDetails.year, state: chrRegoFormDetails.state,  buildYear: chrRegoFormDetails.year};
        } else {
            createRequest = { vin: chrRegoFormDetails.vin, year: chrRegoFormDetails.year, state: chrRegoFormDetails.state,  buildYear: chrRegoFormDetails.year};
        }
        const {data: orderList = []} = await fetchChrServiceOrderListConnect({params: createRequest});
        if (orderList?.length) {
            const {orderId: searchedOrderId, carDetails, status} = orderList[0] || {};
            await updateChrServiceOrderConnect({
                orderId: searchedOrderId,
                payload: {
                    carDetails,
                    id: carDetails?.externalId || carDetails?.id
                }
            });
            if (status === "BOOKED") {
                updateChrFormStateConnect(SCREEN_STATES.REPORT_FOUND);
                return;
            }
        } else {
            await createChrServiceOrder();
        }
        fetchKbbData();

        trackDesktopCustomEventsAU(CHR_GA_EVENTS.FETCHES_KBB, {
            ...CHR_GA_EVENTS.FETCHES_KBB
        });

    };

    const handleVariantSelection = (variantDetails) => {
        setSelectedVariant({
            ...selectedVariant,
            variantId: variantDetails.id,
            variantDetails
        });

        trackDesktopCustomEventsAU(CHR_GA_EVENTS.VARIANT_CHANGES, {
            ...CHR_GA_EVENTS.VARIANT_CHANGES,
            eventLabel: variantDetails.id
        });
    };

    // todo:Deepak update and send selected variant car details
    const updateChrServiceOrder = async ({selectedProductTag, createOrderId = "", carDetails}) => {
        const currentOrderId = createOrderId || orderId;
        const currentVariant = carDetails || selectedVariant.variantDetails;

        try {
            await updateChrServiceOrderConnect({
                orderId: currentOrderId,
                payload: {
                    carDetails: {
                        ...currentVariant,
                        id: currentVariant?.externalId || currentVariant?.id
                    },
                    ...(selectedProductTag && {selectedProductTag})
                }
            });
        } catch (error) {
            // console.log("error", error);
        }
    };

    const updateAndFetchLandingData = async ({selectedProductTag = "", createOrderId = "", carDetails = null, isSingleVariant = false}) => {
        const currentOrderId = createOrderId || orderId;
        await updateChrServiceOrder({selectedProductTag, createOrderId: currentOrderId, carDetails});
        const landingDataResponse = await fetchChrLandingDataConnect({
            orderId: currentOrderId
        });
        const {selectedProductTag: defaultSelectedTag} = landingDataResponse || {};
        await updateChrServiceOrder({selectedProductTag: defaultSelectedTag, createOrderId: currentOrderId, carDetails});
        handleRedirection(carHistoryReportSteps.paymentSummary.route, currentOrderId);

        trackDesktopCustomEventsAU(CHR_GA_EVENTS.ON_PROCEED_TO_REPORT_CLICKED, {
            ...CHR_GA_EVENTS.ON_PROCEED_TO_REPORT_CLICKED
        });
        if (isSingleVariant) {updateChrFormStateConnect(SCREEN_STATES.ENTER_DETAILS);}
    };

    const onReportTypeClick = (selectedItem) => {
        setSelectedProduct({
            ...selectedProduct,
            productTag: selectedItem.productTag,
            productDetails: {
                ...selectedItem
            }
        });
        updateChrServiceOrder({selectedProductDetails: selectedProduct});
    };

    const getReportValuesFromCMS = ({productTag, cmsContent}) => {
        const pageSection = cmsContent?.pageSections || [];
        const paymentHistory = pageSection.find((item) => item.pageSection.name === CMS_SLUG_CONSTANTS.CAR_HISTORY_REPORT_PAYMENT_SUMMARY_DESKTOP) || {};
        const reportTypes = paymentHistory?.pageSection?.meta?.REPORT_TYPES || [];

        const reportDetails = reportTypes.find((item) => item.productTag === productTag);
        if (reportDetails) {
            return {
                included: reportDetails.included || [],
                productTag: reportDetails.productTag || "",
                includesHeading: reportDetails.includesHeading || "",
                content: reportDetails.content || {}
            };
        }
        return {};
    };

    const getFomoSectionFromCMS = ({cmsContent}) => {
        const pageSection = cmsContent?.pageSections || [];
        const paymentHistory = pageSection.find((item) => item.pageSection.name === CMS_SLUG_CONSTANTS.CAR_HISTORY_REPORT_PAYMENT_SUMMARY_DESKTOP) || {};
        const fomoSection = paymentHistory?.pageSection?.meta?.FOMO_SECTION || {};

        return fomoSection;
    };

    const getPaymentSectionFromCMS = ({cmsContent}) => {
        const pageSection = cmsContent?.pageSections || [];
        const paymentHistory = pageSection.find((item) => item.pageSection.name === CMS_SLUG_CONSTANTS.CAR_HISTORY_REPORT_BOOKING_RESULT) || {};
        const paymentSection = paymentHistory?.pageSection?.meta;
        return paymentSection;
    };

    const getReportCtaDisabled = (isEmailRequiredOnCheckout) => {
        const {userEmail, regNo, vin, state} = chrRegoFormDetails || {};
        if (isEmailRequiredOnCheckout && (!state || (!regNo && !vin))) {return true;}

        if (!isEmailRequiredOnCheckout && ((!userEmail || !state) || (!regNo && !vin) || !validateEmail(userEmail))) {
            return true;
        }
        return false;
    };

    const getPageSectionFromName = ({cmsContent, sectionName}) => {
        const pageSection = cmsContent?.pageSections || [];
        const section = pageSection.find((item) => item.pageSection.name === sectionName) || {};
        return section?.pageSection || null;
    };

    const getPaymentSummaryMeta = ({cmsContent}) => {
        const pageSection = cmsContent?.pageSections || [];
        const paymentHistory = pageSection.find((item) => item.pageSection.name === CMS_SLUG_CONSTANTS.CAR_HISTORY_REPORT_PAYMENT_SUMMARY_DESKTOP) || {};
        const meta = paymentHistory?.pageSection?.meta;
        return meta;
    };
    const redirectToMyBookings = () => {
        customPush(routesConstant.my_booking);
        trackDesktopCustomEventsAU(CHR_GA_EVENTS.OPENS_MY_PURCHASES, {
            ...CHR_GA_EVENTS.OPENS_MY_PURCHASES,
            eventCategory: "payment_successfull_page",
            eventAction: "open_my_purchases"
        });
    };

    const getPaymentSummaryUrl = ({serviceOrderId}) => {
        const url = getCarHistoryReportURL(carHistoryReportSteps.paymentSummary.route, queryParams, serviceOrderId);
        return url;
    };

    const onBlurCallback = (value, questionKey) => {
        if (value) {
            trackDesktopCustomEventsAU(CHR_GA_EVENTS.FORM_INPUT, {
                ...CHR_GA_EVENTS.FORM_INPUT,
                eventAction: `${questionKey}_selected`,
                eventLabel: value
            });
        }
    };

    return {
        chrRegoFormDetails,
        handleOnChange,
        handleVinRegoChange,
        isVinActive,
        handleTab,
        handleRedirection,
        fetchKbbDataAndCreateOrder,
        currentFormState,
        regoDetails,
        handleVariantSelection,
        selectedVariant,
        createChrServiceOrder,
        updateChrServiceOrder,
        updateAndFetchLandingData,
        selectedProduct,
        onReportTypeClick,
        getReportValuesFromCMS,
        getFomoSectionFromCMS,
        getPaymentSectionFromCMS,
        getReportCtaDisabled,
        getPaymentSummaryMeta,
        isLoggedIn,
        chrServiceOrderLoading,
        getPageSectionFromName,
        redirectToMyBookings,
        getPaymentSummaryUrl,
        onBlurCallback,
        chrServiceOrder
    };
};

